import React, { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import log from 'loglevel';
import ControlButton from '../../ui/ControlButton';
import { usePlayerContext } from '../../Context';
import {
  Events,
  State,
  ClickAction,
  Autoplay,
  NotificationAction,
} from '../../../types/player';
import { StateChangedEvents } from '../../../sdk/PlayerEvents';
import Mute from './Mute';
import Play from './Play';

const BigButton = () => {
  const { sdk } = usePlayerContext();
  const prefix = sdk.getClassNamePrefix();
  let listeners: any = [];

  const [bigButtonComponent, setBigButtonComponent] = useState<string | null>(
    null,
  );
  //const [init, setInit] = useState<boolean>(false);

  const bigButton = sdk.options().getControls().getBigButton();
  if (!bigButton || bigButton.show === false) return null;

  useEffect(() => {
    sdk.on(Events.BIG_BUTTON_CHANGED, (button: string | null) => {
      setBigButtonComponent(button);
    });
  }, [sdk]);

  useEffect(() => {
    if (sdk.options().getAutoplay() == Autoplay.NO) {
      sdk.setBigButton('play');
    }
  }, []);

  useEffect(() => {
    listeners.push(
      sdk.on(Events.MUTED, (muted: boolean) => {
        if (sdk.getCurrentState() == State.IDLE && muted) {
          log.debug('Events.STATE_CHANGED PLAY setBigButtonComponent to mute');
          sdk.setBigButton('mute');
        }
        if (bigButtonComponent === 'mute' && !muted) sdk.setBigButton(null); //setBigButtonComponent(null);

        if (!bigButton.firstTimeOnly && muted) sdk.setBigButton('mute');
      }),
    );

    listeners.push(
      sdk.on(Events.STATE_CHANGED, (event: StateChangedEvents) => {
        log.debug('Events.STATE_CHANGED PLAY', event, sdk.isLive());
        let bigButtonName = bigButtonComponent;
        if (event.previousState == State.IDLE) {
          if (
            sdk.options().getAutoplay() == Autoplay.NO ||
            event.newState === State.PAUSED
          ) {
            bigButtonName = 'play';
            log.debug(
              'Events.STATE_CHANGED PLAY setBigButtonComponent to  play',
            );
          }
        }

        if (!bigButton.firstTimeOnly && event.newState == State.PAUSED) {
          bigButtonName = 'play';
          log.debug(
            'Events.STATE_CHANGED PAUSED setBigButtonComponent to  play',
          );
        }
        console;
        if (event.newState == State.ENDED && sdk.options().isRewind()) {
          bigButtonName = 'play';
          log.debug(
            'Events.STATE_CHANGED ENDED & Rewind -> setBigButtonComponent to  play',
          );
        }

        if (event.newState == State.PAUSED && sdk.isLive()) {
          bigButtonName = 'play';
          log.debug(
            'Events.STATE_CHANGED PAUSED ON LIVE -> setBigButtonComponent to  play',
          );
        }

        if (event.newState == State.PLAYING) {
          //if (!init) {
          if (sdk.isMuted()) {
            bigButtonName = 'mute';
            log.debug(
              'Events.STATE_CHANGED PLAY setBigButtonComponent to  mute',
            );
          }
          //setInit(true);
          //}
          if (bigButtonName === 'play') {
            bigButtonName = null;
            log.debug(
              'Events.STATE_CHANGED PLAY setBigButtonComponent to  null',
            );
          }
        }
        if (bigButtonName != bigButtonComponent)
          sdk.setBigButton(bigButtonName);
      }),
    );

    return () => {
      listeners.forEach((off: any) => off());
    };
  }, [bigButtonComponent]);

  if (bigButtonComponent && bigButtonComponent !== '') {
  }

  switch (bigButtonComponent) {
    case 'mute':
      return <Mute />;
    case 'play':
      return <Play />;
    default:
      return null;
  }
};

export default BigButton;
